import { Box, TextField, Tooltip, Typography, Zoom } from '@mui/material';

type AdminTooltipFieldProps = {
  value: string;
  onChange: (value: string) => void;
  id: string;
  label?: string;
};

export const TOOLTIP_CHAR_LIMIT = 150;

function AdminTooltipField({ value, onChange, id, label = 'Tooltip' }: Readonly<AdminTooltipFieldProps>) {
  return (
    <Tooltip
      title={
        <Typography variant={'body2'}>
          {'Optional helper text shown when admins need more context for this item.'}
        </Typography>
      }
      TransitionComponent={Zoom}
      enterDelay={200}
      placement={'right'}
    >
      <TextField
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        inputProps={{ maxLength: TOOLTIP_CHAR_LIMIT }}
        sx={{ width: '100%' }}
        id={id}
        label={label}
        variant="outlined"
        multiline
        minRows={2}
        helperText={
          <Box sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>{`${value.length}/${TOOLTIP_CHAR_LIMIT} character(s)`}</Box>
        }
      />
    </Tooltip>
  );
}

export default AdminTooltipField;
